import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useHead } from '@unhead/vue';
import { getCurrentInstance, onMounted, provide, ref } from 'vue';
import type { ITask } from './interfaces';
import { type BuefyInstance, SharedBuefy } from './services/sharedBuefy';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useHead({
  titleTemplate: '%s | DailyNotes',
});

const taskList = ref<ITask[]>([]);

provide('global', {
  taskList,
});

onMounted(() => {
  const instance = getCurrentInstance();
  if (instance) {
    const buefy = (instance.appContext.config.globalProperties as { $buefy?: BuefyInstance })
      .$buefy;
    if (buefy) {
      SharedBuefy.notifications = buefy.toast;
      SharedBuefy.dialog = buefy.dialog;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})